import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { makeStyles } from "@material-ui/core/styles";
import FilterButton from "../../components/Common/FilterButton";
import PrizeItemList from "../../components/PrizeItem/PrizeItemList";
import PrizeItemFormModal from "../../components/PrizeItem/PrizeItemFormModal";
import ListPagination from "../../components/Common/ListPagination";
import CommonStyles from "../../static/styles/common";
import BulkPrizeItemUplaod from "../../components/PrizeItem/BulkPrizeItemUploadModal/index";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as PrizeItemActions from "../../store/actions/PrizeItem";
import Permission from "../../components/Common/Permission";
import MenuActionsMappings from "../../constants/Menu/MenuActionsMappings";
import MenuNames from "../../constants/Menu/MenuNames.json";
import { FlexContainer, Heading } from "../../constants/assets/containers";
import Button from "sushiweb/Button";
import { isMobile } from "../../utils";

const useStyles = makeStyles((theme) => ({
  actionBar: {
    ...CommonStyles.actionBar,
    "& > button": {
      marginLeft: "20px",
    },
  },
}));

const PrizeItem = (props) => {
  const classes = useStyles();
  const [modalState, setModalState] = useState(false);
  const [activeItem, setActiveItem] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const allActions = MenuActionsMappings[MenuNames.PRIZE_ITEMS];

  const filterFields = ["name"];

  const handleClick = (type, item) => {
    setActiveItem(item);
    setModalState(type);
  };

  const handleClose = () => {
    setModalState(false);
  };

  //handle pagination
  const handleNavClick = (action) => {
    if (action === "prev") {
      let pageRequest = {
        page: currentPage - 1,
      };
      setCurrentPage(currentPage - 1);
      props.getPrizeItemList(props.activeFilters, pageRequest);
    } else {
      let pageRequest = {
        page: currentPage + 1,
      };
      setCurrentPage(currentPage + 1);
      props.getPrizeItemList(props.activeFilters, pageRequest);
    }
  };

  const getModal = () => {
    switch (modalState) {
      case "Add":
        return <BulkPrizeItemUplaod customHandleClose={handleClose} />;
      case "Edit":
        return (
          <PrizeItemFormModal
            activeItem={activeItem}
            modalState={modalState}
            handleClose={handleClose}
          />
        );
      case "Filter":
        return (
          <PrizeItemFormModal
            activeItem={activeItem}
            modalState={modalState}
            handleClose={handleClose}
            filterFields={filterFields}
          />
        );
      default:
        return;
    }
  };

  useEffect(() => {
    props.getPrizeItemList({});
  }, []);

  useEffect(() => {
    setCurrentPage(1);
  }, [JSON.stringify(props.activeFilters)]);

  return (
    <PrizeItemViewContainer className="PrizeItems-View container">
      <FlexContainer align="flex-start">
        <Heading>Prize Items</Heading>
        <div className="actionBar mb-20 flex items-center justify-end">
          <Permission requiredPerms={[allActions.LIST]}>
            <FilterButton
              activeFilters={props.activeFilters}
              handleClick={() => handleClick("Filter", null)}
            />
          </Permission>
          <Permission requiredPerms={[allActions.BULK_CREATE]}>
            <Button
              onClick={() => handleClick("Add", null)}
              className="sushi-btn ml-12"
              data-testid="prizeItemAddNewBtn"
            >
              Bulk Upload
            </Button>
          </Permission>
        </div>
      </FlexContainer>
      <PrizeItemList
        prizeItemList={props.prizeItemList}
        handleClick={handleClick}
      />
      <ListPagination
        nextPage={props.nextPage}
        prevPage={props.prevPage}
        handleNavClick={handleNavClick}
      />
      {modalState && getModal()}
    </PrizeItemViewContainer>
  );
};

const PrizeItemViewContainer = styled.div`
  & > div {
    flex-direction: ${isMobile() ? "column" : "row"};
    .actionBar {
      margin-top: ${isMobile() ? "10px" : "unset"};
      margin-left: ${isMobile() ? "unset" : "auto"};
    }
  }
`;

function mapStateToProps(state) {
  const { PrizeItem } = state;
  return {
    prizeItemList: PrizeItem.prizeItemList,
    nextPage: PrizeItem.nextPage,
    prevPage: PrizeItem.prevPage,
    activeFilters: PrizeItem.activeFilters,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getPrizeItemList: bindActionCreators(
      PrizeItemActions.getPrizeItemList,
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PrizeItem);
